import {
  WidgetAccountAccessCodeRequest,
  WidgetAccountAccessCodeResponse,
  WidgetAccountHomeResponse,
  WidgetAccountPaymentLinkRequest,
  WidgetAccountPaymentLinkResponse,
  WidgetAccountRequestCodeRequest,
  WidgetAccountRequestCodeResponse,
  WidgetAccountVerifyCodeRequest,
  WidgetAccountVerifyCodeResponse
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

/**
 * Widget Account tab — phone → SMS code → verified flow.
 * Both endpoints are public; visitor scope comes from the
 * HMAC-signed signedVisitorId in the body.
 */
export class WidgetAccountAPI {
  static async requestCode(body: WidgetAccountRequestCodeRequest) {
    return APIService.Server.post<WidgetAccountRequestCodeResponse>(`/widget-account/code/request`, body);
  }

  static async verifyCode(body: WidgetAccountVerifyCodeRequest) {
    return APIService.Server.post<WidgetAccountVerifyCodeResponse>(`/widget-account/code/verify`, body);
  }

  static async home(publicId: string, signedVisitorId: string) {
    return APIService.Server.get<WidgetAccountHomeResponse>(
      `/widget-account/home/${encodeURIComponent(publicId)}?signedVisitorId=${encodeURIComponent(signedVisitorId)}`
    );
  }

  static async paymentLink(body: WidgetAccountPaymentLinkRequest) {
    return APIService.Server.post<WidgetAccountPaymentLinkResponse>(`/widget-account/payment-link`, body);
  }

  /** Live gate-code fetch for one unit. POST so the code stays out of URLs and logs. */
  static async accessCode(body: WidgetAccountAccessCodeRequest) {
    return APIService.Server.post<WidgetAccountAccessCodeResponse>(`/widget-account/access-code`, body);
  }
}
